export default __webpack_public_path__ + "154d4f0e6417ce3936178119ace77fa9.png";